import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { forgetPassword, loginAndStoreToken } from "../utils/api/authAPI";
import { signInUrl } from "../utils/config";
import { Spinner } from "react-bootstrap";
import { toast } from "sonner";

const SignInLayer = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoginFailed, setLoginFailed] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true)
      setLoginFailed("");
      const result = await loginAndStoreToken(email, password, signInUrl);
      if (result) {
        window.location.href = "/";
      } else {

        setLoginFailed("Login failed: Wrong Credential");
      }
    } catch (err) {
      setLoginFailed(err)
    } finally {
      setIsLoading(false);
    }
  };
  const handleForgetPassword = async () => {
    try {
      if (email === "") {
        toast.error("Please enter your email");
        return;
      }
      
      // Show success message immediately
      toast.success("Password reset link sent to your email");
      
      // Call API in background
      const response = await forgetPassword(email);
      // You can add additional handling here if needed based on response
    } catch(e) {
      // If API fails, show error and hide the success message
      toast.error(e.message || "Something went wrong. Please try again.");
    }
  }


  return (
    <section className='auth bg-base d-flex flex-wrap'>
      <div className='auth-left d-lg-block d-none'>
        <div
          className='d-flex align-items-center flex-column h-100 justify-content-center'
          style={{
            backgroundColor: 'black',
            textAlign: 'center',
            padding: '0rem',
          }}
        >
          <h1 style={{ color: 'white', fontSize: '1.5rem', fontWeight: 'bold' }}>
            Put <span style={{ color: '#3EE6A8' }}>AI</span> To Work
          </h1>
          <img
            src='/assets/images/auth/wave.gif' 
            alt='Wave animation'
            style={{
              width: '80%',
              maxWidth: '400px',
              marginTop: '0' 
            }}
          />
        </div>
      </div>
      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
        <div className='max-w-464-px mx-auto w-100'>
          <div>
            <Link to='/' className='mb-40 max-w-290-px'>
              <img src='assets/images/logo.png' alt='' />
            </Link>
            <h4 className='mb-12'>Sign In to your Account</h4>
            <p className='mb-32 text-secondary-light text-lg'>
              Welcome back! please enter your detail
            </p>
          </div>
          <form onSubmit={handleLogin}>
            <div className='icon-field mb-16'>
              <span className='icon top-50 translate-middle-y'>
                <Icon icon='mage:email' />
              </span>
              <input
                type='email'
                className='form-control h-56-px bg-neutral-50 radius-12'
                placeholder='Email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className='position-relative mb-20'>
              <div className='icon-field'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  id='your-password'
                  placeholder='Password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <span
                className='cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <Icon icon={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'} />
              </span>
            </div>
            
            {/* Remember me and Forgot Password in same line */}
            <div className='d-flex justify-content-between align-items-center mb-10'>
              <div className='form-check style-check d-flex align-items-center'>
                <input className='form-check-input border border-neutral-300' type='checkbox' id='remeber' />
                <label className='form-check-label' htmlFor='remeber'>
                  Remember me
                </label>
              </div>
              
              <button
                type='button'
                onClick={handleForgetPassword}
                className='text-primary-500 fw-medium text-sm text-decoration-none border-0 bg-transparent'
                style={{ cursor: 'pointer' }}
              >
                Forgot Password?
              </button>
            </div>
            <button
              type='submit'
              className='btn btn-primary-500 text-sm btn-sm px-12 py-20 w-100 radius-12 mt-32'
              disabled={isLoading}
            >
              {isLoading ? <Spinner /> : 'Sign In'}
            </button>

            {/* Create New Account Link */}
            <div className='text-center mt-20'>
              <Link to='/sign-up' className='text-primary-500 fw-medium text-sm'>
                Don't have an account? Create New Account
              </Link>
            </div>

            {/* Display the error message if login fails */}
            {isLoginFailed && (
              <div
                style={{
                  marginTop: '1rem',
                  textAlign: 'center',
                  color: 'red',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                {isLoginFailed}
              </div>
            )}
            {/* <div className='mt-32 center-border-horizontal text-center'>
              <span className='bg-base z-1 px-4'>Or sign in with</span>
            </div> */}
            {/* <div className='mt-32 d-flex align-items-center gap-3'>
              <button type='button' className='fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50'>
                <Icon icon='ic:baseline-facebook' className='text-primary-600 text-xl line-height-1' />
                Facebook
              </button>
              <button type='button' className='fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50'>
                <Icon icon='logos:google-icon' className='text-primary-600 text-xl line-height-1' />
                Google
              </button>
            </div> */}
            {/* <div className='mt-32 text-center text-sm'>
              <p className='mb-0'>
                Don’t have an account?{" "}
                <Link to='/sign-up' className='text-primary-600 fw-semibold'>
                  Sign Up
                </Link>
              </p>
            </div> */}
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
